import DataProvider from './DataProvider';

// TODO: [JIRA-XXXX] remove in next PR

export default DataProvider;
